<template>
  <div class="widget px-3 pt-3 pb-2">
    <i class="fas fa-users icon"> </i>
    <span class="title ml-2">{{ $t("dashboard.metrics.Guests.title").toUpperCase() }}</span>
    <div class="row mt-2">
      <div class="col">
        <span class="explain">Equipes</span>
        <br />
        <span class="metric">
          <span> {{ guests.Bookings }} </span>
        </span>
      </div>
      <div class="col">
        <span class="explain">Personen</span>
        <br />
        <span class="metric">
          <span> {{ guests.Guests }} </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const MetricRepository = RepositoryFactory.get("MetricRepository");
import moment from "moment";

export default {
  data() {
    return {
      guests: {
        Bookings: 0,
        Guests: 0
      }
    };
  },

  computed: {
    ...mapState("Campsites", ["currentCampsite"])
  },

  watch: {
    currentCampsite() {
      this.getMetrics();
    }
  },

  mounted() {
    this.getMetrics();
  },

  methods: {
    getMetrics: function () {
      MetricRepository.getGuests(this.currentCampsite.id, moment().startOf("day").toDate(), moment().endOf("day").toDate(), "ShortStay").then((response) => {
        response.data.dimensions.forEach((e) => (this.guests[e.name] = e.value));
      });
    }
  }
};
</script>
